import './Header.css';
import * as React from 'react';
import { addClass, Bem } from '../../utils';
import { HeaderBrand } from './HeaderBrand';
import { HeaderTime } from './HeaderTime';
import { HeaderItem } from './HeaderItem';
import { HeaderMenu } from './HeaderMenu';
import { HeaderMenuGroup } from './HeaderMenuGroup';
import { HeaderMenuItem } from './HeaderMenuItem';
import { HeaderMenuItemSeparator } from './HeaderMenuItemSeparator';
import { useId } from '../../utils/hooks/useId';
import './Header.css';
const bem = Bem.create('vai-header');
export function Header(props) {
    const { children, htmlId, htmlTitle, time, timeDetails, title, logoVisible, hasNavigation, displayShadow, dataTa, className, animated, ...rest } = props;
    const id = useId(htmlId, ['header']);
    const headerClasses = addClass(bem.block(displayShadow && 'shadow', animated && 'animated', hasNavigation && 'with-navigation'), className);
    return (React.createElement("header", Object.assign({ id: id.toString(), "data-ta": dataTa, className: headerClasses, title: htmlTitle }, rest),
        React.createElement(HeaderBrand, { animated: animated, visible: logoVisible }),
        time && React.createElement(HeaderTime, { htmlId: id.toHtmlId(), time: time, details: timeDetails, dataTa: "vai-header-time" }),
        React.createElement("h1", { id: id.copyWith(['title']).toString(), className: bem.element('title')(), "data-ta": "vai-header-title" }, title),
        React.createElement("div", { id: id.copyWith(['action-container']).toString(), className: bem.element('children')() }, children)));
}
Header.defaultProps = {
    dataTa: 'vai-header',
    animated: true,
    hasNavigation: true,
};
Header.Item = HeaderItem;
Header.Menu = HeaderMenu;
Header.MenuItem = HeaderMenuItem;
Header.MenuGroup = HeaderMenuGroup;
Header.MenuItemSeparator = HeaderMenuItemSeparator;
//# sourceMappingURL=Header.js.map